import revive_payload_client_4sVQNw7RlN from "/var/www/frontend-prod/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/var/www/frontend-prod/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/var/www/frontend-prod/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/var/www/frontend-prod/node_modules/nuxt/dist/app/plugins/payload.client.js";
import components_plugin_KR1HBZs4kY from "/var/www/frontend-prod/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/var/www/frontend-prod/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_adVF2uRka6 from "/var/www/frontend-prod/node_modules/nuxt-bugsnag/dist/runtime/client/plugin.js";
import plugin_tbFNToZNim from "/var/www/frontend-prod/node_modules/@zadigetvoltaire/nuxt-gtm/dist/runtime/plugin.mjs";
import plugin_eTVJQYlCmx from "/var/www/frontend-prod/node_modules/@nuxtjs/apollo/dist/runtime/plugin.mjs";
import composition_sLxaNGmlSL from "/var/www/frontend-prod/node_modules/@nuxtjs/i18n/dist/runtime/plugins/composition.mjs";
import i18n_yfWm7jX06p from "/var/www/frontend-prod/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/var/www/frontend-prod/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/var/www/frontend-prod/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import apollo_plugin_global_li3sDDO0eR from "/var/www/frontend-prod/plugins/apollo-plugin.global.js";
import lead_tracking_client_aqf56T1SUT from "/var/www/frontend-prod/plugins/lead-tracking.client.js";
import loading_JsMeH12IfP from "/var/www/frontend-prod/plugins/loading.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_adVF2uRka6,
  plugin_tbFNToZNim,
  plugin_eTVJQYlCmx,
  composition_sLxaNGmlSL,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  check_outdated_build_client_8vK7RkfGxZ,
  apollo_plugin_global_li3sDDO0eR,
  lead_tracking_client_aqf56T1SUT,
  loading_JsMeH12IfP
]